const loadMoreBtn = document.querySelector('.load-more__btn')

if (loadMoreBtn) {
  const currentUrl = window.location.href.split('?')
  const category = currentUrl[1]
    ? currentUrl[1].split('#')[0].split('&page=')[0]
    : ''

  let currentPage =
    (currentUrl[1] && currentUrl[1].split('#')[0].split('&page=')[1]) || 1

  loadMoreBtn.addEventListener('click', () => {
    // Increment page parameter
    currentPage++
    //Load new items
    window.location.href =
      currentUrl[0] +
      '?' +
      category +
      '&page=' +
      currentPage +
      '#filter-results'
  })
}
